import main from 'main';
import _ from 'underscore';
import s from 'underscore.string'

let mod = {};

mod.deepMerge = function(target, source)
{
  if(target === source)
    return target;

  target = _.clone(target);
  source = _.clone(source);

  if(typeof(target) === 'object' && target !== null &&
    typeof(source) === 'object')
  {
    for(let key in source)
    {
      if(typeof(target[key]) === 'object' && target[key] !== null &&
        typeof(source[key]) === 'object')
        target[key] = this.deepMerge(target[key], source[key]);

      else
      {
        if(!isNaN(parseFloat(key)) && isFinite(key))
          target.push(source[key]);
        else
          target[key] = source[key];
      }
    }
  }

  else
    target = source;

  return target;
};

mod.formatBytesToHuman = function(bytes, params)
{
  params = Object.assign({
    addUnit: true,
    targetUnit: 'auto'
  }, params);

  bytes = parseFloat(bytes);

  if(params.targetUnit === 'auto')
    params.targetUnit = mod.getReasonableByteUnit(bytes);

  if(params.targetUnit === 'bytes')
    return s.numberFormat(parseFloat(bytes), 0, main.framework.dict['default'].decimalPoint, main.framework.dict['default'].thousandsSeparator) + (params.addUnit ? ' '+ main.framework.dict['default'].byteShort : '');
  else if(params.targetUnit === 'kibibytes')
    return s.numberFormat(parseFloat((bytes / 1024).toFixed(2)), 2, main.framework.dict['default'].decimalPoint, main.framework.dict['default'].thousandsSeparator) + (params.addUnit ? ' '+ main.framework.dict['default'].kibibyteShort : '');
  else if(params.targetUnit === 'mebibytes')
    return s.numberFormat(parseFloat((bytes / 1024 / 1024).toFixed(2)), 2, main.framework.dict['default'].decimalPoint, main.framework.dict['default'].thousandsSeparator) + (params.addUnit ? ' '+ main.framework.dict['default'].mebibyteShort : '');
  else
    return s.numberFormat(parseFloat((bytes / 1024 / 1024 / 1024).toFixed(2)), 2, main.framework.dict['default'].decimalPoint, main.framework.dict['default'].thousandsSeparator) + (params.addUnit ? ' '+ main.framework.dict['default'].gibibyteShort : '');
};

mod.formatBytesOfTotalBytesToHuman = function(bytes, totalBytes, params)
{
  params = Object.assign({
    separator: ' / ',
    targetUnit: 'auto'
  }, params);

  if(params.targetUnit === 'auto')
    params.targetUnit = mod.getReasonableByteUnit(totalBytes);

  return mod.formatBytesToHuman(bytes, {
    addUnit: false,
    targetUnit: params.targetUnit
  }) + params.separator + mod.formatBytesToHuman(totalBytes, {
    targetUnit: params.targetUnit
  });
};

mod.getReasonableByteUnit = function(bytes)
{
  if(bytes < 500)
    return 'bytes';
  else if(bytes < 500 * 1024)
    return 'kibibytes';
  else if(bytes < 500 * 1024 * 1024)
    return 'mebibytes';
  else
    return 'gibibytes';
};

export default mod;



// WEBPACK FOOTER //
// ./vendor/kuvio-framework/kustaa/applications/publicFrontend/scripts/libraries/utility.js